if (!customElements.get('ortho-subnav')) {
  customElements.define('ortho-subnav', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.sentinel = document.querySelector('[data-osn-sentinel]');
      this.names = { 'pdp-pitch': 'Why it works', 'pdp-overview': 'Overview', 'pdp-day': 'A day on one seat', 'pdp-benefits': 'Benefits', 'pdp-design': 'Design', 'pdp-compare': 'Compare', 'pdp-motion': 'In motion', 'pdp-how': 'How to use', 'pdp-cases': 'Where it works', 'pdp-specs': 'Details', 'pdp-faq': 'Questions' };
      this.onScroll = this.onScroll.bind(this);
      this.build();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', () => this.moveInk(), { passive: true });
      document.addEventListener('shopify:section:load', () => this.build());
      this.onScroll();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
    build() {
      this.secs = [].slice.call(document.querySelectorAll('[data-pdp-section]')).filter((s) => s.id);
      this.track.innerHTML = '';
      this.ink = document.createElement('span');
      this.ink.className = 'osn__ink';
      this.track.appendChild(this.ink);
      this.links = this.secs.map((s) => {
        const a = document.createElement('a');
        a.className = 'osn__link';
        a.href = '#' + s.id;
        a.textContent = s.dataset.label || this.names[s.id] || (s.querySelector('h2') || {}).textContent || s.id;
        a.addEventListener('click', (e) => {
          e.preventDefault();
          const hb = this.headerBottom();
          const top = s.getBoundingClientRect().top + window.scrollY - hb - this.offsetHeight - 8;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.track.appendChild(a);
        return a;
      });
      if (this.links.length < 3) this.setAttribute('data-off', ''); else this.removeAttribute('data-off');
    }
    headerBottom() {
      const h = document.querySelector('header');
      if (!h) return 0;
      const r = h.getBoundingClientRect();
      return Math.max(0, Math.round(r.bottom));
    }
    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        const hb = this.headerBottom();
        this.style.top = hb + 'px';
        const past = this.sentinel ? this.sentinel.getBoundingClientRect().top < hb : false;
        if (past) this.setAttribute('data-show', ''); else this.removeAttribute('data-show');
        let cur = -1;
        const line = hb + this.offsetHeight + 120;
        this.secs.forEach((s, i) => { if (s.getBoundingClientRect().top <= line) cur = i; });
        this.links.forEach((a, i) => { if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
        this.cur = cur;
        this.moveInk();
      });
    }
    moveInk() {
      const a = this.links && this.links[this.cur];
      if (!a) { if (this.ink) this.ink.style.opacity = 0; return; }
      this.ink.style.opacity = 1;
      this.ink.style.width = a.offsetWidth + 'px';
      this.ink.style.transform = 'translateX(' + a.offsetLeft + 'px)';
      const t = this.track;
      if (t.scrollWidth > t.clientWidth) t.scrollTo({ left: a.offsetLeft - 24, behavior: 'smooth' });
    }
  });
}
